const mainEl = document.querySelector("#main");
let setBackgroundPositionY = () => {
    document.body.style.backgroundPositionY =`${mainEl.offsetHeight}px`
}
window.addEventListener("load", setBackgroundPositionY);
window.addEventListener("resize", setBackgroundPositionY);


// ナビゲーション処理
const fixNav = document.getElementById('fix-nav');
const coverImage = document.getElementById('main');
const coverImageHeight = coverImage.clientHeight;
const sections = document.querySelectorAll('#message, #events, #countdown');
const navLinks = document.querySelectorAll('#fix-nav a');
const burger = document.querySelector('.burger-menu');
const messageSection = document.getElementById('message');

function updateNav() {
    if (window.innerWidth < 769) {
        return;
    }
    let currentSection = '';
    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const sectionHeight = section.offsetHeight;
        if (window.scrollY >= sectionTop - 1 && window.scrollY < sectionTop + sectionHeight - 1) {
            currentSection = section.getAttribute('id');
        }
    });

    // ページの一番下に到達した場合
    if (scrollPosition >= documentHeight - 1) {
        currentSection = 'rsvp';
    }

    navLinks.forEach(link => {
        link.classList.remove('active');
        if (currentSection && link.getAttribute('href').includes(currentSection)) {
            link.classList.add('active');
        }
    });

    // fixNavの表示/非表示を切り替え
    if (!fixNav){ return; }

    const coverImageBottom = coverImage ? coverImage.getBoundingClientRect().bottom + window.pageYOffset : 0;
    if (window.scrollY >= coverImageBottom) {
        fixNav.style.position = 'fixed';
        fixNav.style.top = '80px';
        fixNav.classList.add('active');
        return;
    }

    if (messageSection != null) {
        const messageSectionTop = messageSection.getBoundingClientRect().top + window.pageYOffset;
        if (window.scrollY + window.innerHeight >= messageSectionTop) {
            fixNav.classList.add('active');
            fixNav.style.position = 'absolute';
            fixNav.style.top = `${messageSectionTop + 80 }px`;
            return;
        }
    }

    fixNav.classList.remove('active');
    fixNav.style.position = '';
    fixNav.style.top = '';
    }
window.addEventListener('scroll', function() {
    updateNav();
});
window.addEventListener('resize', function() {
    updateNav();
});


burger.addEventListener('click', function () {
    fixNav.classList.toggle('open');
});
navLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        fixNav.classList.remove('open');
    });
});




// フッター位置調整
// let footer = document.querySelector('#footer');
// let contentBgEl = document.querySelector('.js-content-bg');
// contentBgEl.appendChild(footer);






// イベントタイトル切り替え
const eventsEl = document.querySelector('#events');
const event02El = document.querySelector('#events .event02');

if (eventsEl && event02El) {
    eventsEl.classList.add("events");
}




///イベントタイトルがない場合
const eventTitleEls = document.querySelectorAll('.event_title h3');
const eventDayEls = document.querySelectorAll('.event_day');

eventTitleEls.forEach((titleEl, index) => {
    if (!titleEl.textContent.trim()) { // 空白のみの場合も考慮
        eventDayEls[index]?.classList.add('is-LineNotShow'); // 要素が存在する場合のみ適用
    }
});


// IntersectionObserver
window.addEventListener(
    "load",
    function () {
      function callback(entries) {
        for (let i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add("is-active");
          }
        }
      }
  
      let options = {
        root: null,
        rootMargin: "-40% 0px",
        threshold: 0.0,
      };
  
      let observer = new IntersectionObserver(callback, options);
  
      var editor = document.querySelector("#editor");
      var events = document.querySelector("#events");
      var eventsDaytime = document.querySelectorAll(".events_daytime");
      var eventsPlace = document.querySelectorAll(".events_place");
      var placeOthers = document.querySelectorAll('.place_others');
      var countdown = document.querySelector("#countdown");
      let observeropcity = function () {
        if(editor != null){
            observer.observe(editor);
        }
        observer.observe(events);
        for (let i = 0; i < eventsDaytime.length; i++){
            if(eventsDaytime[i] != null){
                observer.observe(eventsDaytime[i]);
            }
        }
        for (let i = 0; i < eventsPlace.length; i++){
            if(eventsPlace[i] != null){
                observer.observe(eventsPlace[i]);
            }
        }
        for (let i = 0; i < placeOthers.length; i++){
            if(placeOthers[i]!= null){
                observer.observe(placeOthers[i]);
            }
        }
        if(countdown != null){
            observer.observe(countdown);
        }
      };
      observeropcity();
    },
    false
  );
  